import React, { useState } from "react";
import { Container, Form, Button, Alert } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import authApi from "../../data/api/authApi";
import { useLanguage } from "../helpers/LanguageContext";
import "../../css/ResetPassword.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [variant, setVariant] = useState("danger");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword === "Welcome1") {
      setVariant("danger");
      setMessage(t("resetPasswordWelcome1Error"));
      return;
    }

    if (newPassword !== confirmPassword) {
      setVariant("danger");
      setMessage(t("resetPasswordMismatch"));
      return;
    }

    setSubmitting(true);

    try {
      const response = await authApi.resetPasswordApi({ token, newPassword });
      const { success, message: serverMsg } = response.data;

      if (response.status === 409 || success === false) {
        setVariant("danger");
        setMessage(serverMsg || t("resetPasswordSameAsPrevious"));
      } else {
        setVariant("success");
        setMessage(t("resetPasswordSuccess"));
        setTimeout(() => navigate("/login"), 2000);
      }
    } catch (err) {
      console.error("ResetPassword error:", err);
      const status = err.response?.status;
      const serverMsg = err.response?.data?.message;

      if (status === 409) {
        setVariant("danger");
        setMessage(serverMsg || t("resetPasswordSameAsPrevious"));
      } else {
        setVariant("danger");
        setMessage(t("resetPasswordError"));
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container fluid className="reset-password-page">
      <div className="reset-password-card shadow-sm">
        <h3 className="reset-password-title">{t("resetPasswordTitle")}</h3>

        {message && (
          <Alert variant={variant} className="reset-password-alert">
            {message}
          </Alert>
        )}

        <Form onSubmit={handleSubmit} className="reset-password-form">
          <Form.Group className="mb-3" controlId="newPassword">
            <Form.Label>{t("newPassword")}</Form.Label>
            <Form.Control
              type="password"
              placeholder={t("newPasswordPlaceholder")}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="reset-password-input"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="confirmPassword">
            <Form.Label>{t("repeatPassword")}</Form.Label>
            <Form.Control
              type="password"
              placeholder={t("repeatPasswordPlaceholder")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="reset-password-input"
            />
          </Form.Group>

          <div className="d-grid reset-password-actions">
            <Button
              type="submit"
              disabled={submitting}
              className="reset-password-submit-btn"
            >
              {submitting ? t("saving") : t("resetPasswordSubmit")}
            </Button>
          </div>
        </Form>
      </div>
    </Container>
  );
};

export default ResetPassword;
